<template>
  <div class="upload-excel payout-upload-excel-file">
    <el-upload
      v-if="!uploading"
      :ref="'upload_'+ type"
      action="#"
      :auto-upload="false"
      :limit="limitNum"
      accept=".xls,.xlsx"
      :on-change="handleFile.bind(this,type)"
      :on-remove="handleRemove.bind(this,type)"
      :on-exceed="handleFileExceed.bind(this,type)"
      :file-list="fileList"
    >
      <div class="upload-container">
        <el-button
          plain
          size="small"
          type="info"
        >    <svg-icon icon-class="upload-mark-link" style="margin-right: 10px;" />{{ $t('tips.click_to_upload_attach') }}</el-button>
      </div>

    </el-upload>
    <div v-if="uploading" class="parse">
      Parsing
    </div>
    <Progress :progress="uploadingProgress" />

    <el-dialog
      :title="$t('system.user_authentication')"
      :close-on-click-modal="false"
      class="dialog-card"
      :visible.sync="dialogVisible"
      width="500px"
      :modal="false"
      @close="initData"
    >
      <div class="header-line" />
      <div style="width: 420px; font-style: normal;font-weight: 400;font-size: 18px;line-height: 22px;color: #4B5567;">
        <p>{{ $t('tips.MFA_verification_code_authenticate_user_access') }}</p>
      </div>
      <el-form ref="form" :model="form" :rules="rules" style="margin-top: 30px">
        <el-form-item prop="mfa_code" required>
          <el-input
            v-model="form.mfa_code"
            placeholder="Enter your MFA verification code"
            class="search-mfa-frame"
            autocomplete="off"
            maxlength="6"
            clearable
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :disabled="submiting" @click="onClickSubmitApproveBtn">{{ $t('components.submit') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('payment_links.duplicate_upload_detected')"
      :close-on-click-modal="false"
      class="dialog-card"
      :visible.sync="sameDialogVisible"
      width="500px"
      :modal="false"
      @close="onClickCancelUpload"
    >
      <div class="header-line" />
      <div style="display: flex; align-items: center;word-break: keep-all;font-size: 14px;line-height: 22px;color: #4B5567;">
        <div class="el-message-box__status el-icon-warning" style="position: static;margin: 40px 10px 0 0; " />
        <p style="margin: 20px 0 -15px">{{ $t('payment_links.tip_6') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="submiting" @click="onClickProceedUpload ">{{ $t('payment_links.proceed_upload') }}</el-button>
        <el-button type="primary" @click="onClickCancelUpload">{{ $t('payment_links.cancel_upload') }}</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>
// import { uploadFileShowProgress } from '@/api/components/upload'
import { uploadTransTemplateExcel, checkoutFileIsSame } from '@/api/online-transaction/online-transaction'
import CryptoJS from 'crypto-js'
export default {
  name: 'UpdateFile',
  components: {
    Progress: () => import('@/views/components/Progress.vue')
  },
  props: {
    limitNum: {
      type: Number,
      default: 1000
    },
    type: {
      type: String,
      default: ''
    },
    referenceBatchNo: {
      type: [Number, String],
      default: 0
    }

  },
  data() {
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length !== 6 || !/^\d+$/.test(value)) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    return {
      fileList: [],
      removeFiles: [],
      submiting: false,
      uploadingProgress: 0,
      uploading: false,
      dialogVisible: false,
      sameDialogVisible: false,
      form: {
        mfa_code: ''
      },
      currentFile: null,
      rules: {
        mfa_code: [
          { validator: validateVerifyCode, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    async handleFile(type, file, fileList) {
      let md5
      try {
        md5 = await this.calculateFileMD5(file.raw)
      } catch (error) {
        this.removeUploadFile(type, file)
        return
      }

      checkoutFileIsSame({ md5 }).then(res => {
        const { file_exist, token } = res.data || {}
        this.form.token = token
        // 保存当前文件信息
        this.currentFile = file
        if (this.uploading) {
          this.$message.warning('Uploading, pls wait!')
          return
        }
        this.uploading = false
        if (file_exist) {
          this.sameDialogVisible = true
          return
        }
        this.toSubmitFile()
      })
    },
    toSubmitFile() {
      // 显示 MFA 对话框
      // if (this.$store.getters.isOpenMfa) {
      this.form.mfa_code = ''
      setTimeout(() => {
        this.dialogVisible = true
      }, 400)
      // } else {
      // this.onClickSubmitApproveBtn(false)
      // }
    },
    onClickCancelUpload() {
      this.sameDialogVisible = false
      this.removeUploadFile(this.type, this.currentFile)
    },
    onClickProceedUpload() {
      this.sameDialogVisible = false
      this.toSubmitFile()
    },

    onClickSubmitApproveBtn(validate = true) {
      if (validate) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitFile() // 验证通过后提交文件
          }
        })
      } else {
        this.submitFile() // 不需要验证，直接提交文件
      }
    },
    submitFile() {
      this.submiting = true
      const { mfa_code, token } = this.form
      const params = {}
      const formData = new FormData()
      formData.append('file', this.currentFile.raw)
      formData.append('reference_batch_no', this.referenceBatchNo)
      formData.append('mfa_code', mfa_code)
      formData.append('token', token)
      params.data = formData
      // 上传进度，固定到大概95%，等后台响应成功显示100%
      params.onUploadProgress = (progressEvent) => {
        const value = Math.floor((progressEvent.loaded * 100) / (progressEvent.total * 1.05))
        this.uploadingProgress = value
      }

      uploadTransTemplateExcel(params).then(res => {
        if (res.code === 10000) {
          if (this.removeFiles.includes(this.currentFile.uid)) {
            return
          }
          this.$emit('templateFileSuccess', res.data)
          this.fileList = []
          this.uploadingProgress = 100
          setTimeout(() => {
            this.uploadingProgress = 0
          }, 500)
        }
      }).catch((err) => {
        // 上传失败，文件还是会显示，要移除文件
        console.error('err', err)
        this.fileList = []
        const uid = this.currentFile.uid
        const idx = this.$refs['upload_' + this.type].uploadFiles.findIndex(item => item.uid === uid)
        if (idx !== -1) {
          this.$refs['upload_' + this.type].uploadFiles.splice(idx, 1)
        }
      }).finally(() => {
        this.uploading = false
        this.uploadingProgress = 0
        this.dialogVisible = false
        this.submiting = false
      })
    },
    async calculateFileMD5(file) {
      const reader = new FileReader()
      return new Promise((resolve, reject) => {
        reader.onload = (e) => {
          const arrayBuffer = e.target.result
          const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer)
          const hash = CryptoJS.MD5(wordArray).toString()
          resolve(hash)
        }
        reader.onerror = reject
        reader.readAsArrayBuffer(file)
      })
    },
    removeUploadFile(type = '', file) {
      const uid = file.uid
      if (!this.$refs['upload_' + type]) {
        return
      }
      const idx = this.$refs['upload_' + type].uploadFiles.findIndex(item => item.uid === uid)
      if (idx !== -1) {
        this.$refs['upload_' + type].uploadFiles.splice(idx, 1)
      }
    },
    handleRemove(type, file, fileList) {
      this.fileList = fileList
      if (file.status === 'ready') {
        // 重置进度条
        this.uploadingProgress = 0
        // 重置上传状态
        this.uploading = false
        // 正在上传中，移除，添加记录，等上传成功之后不进行处理
        this.removeFiles.push(file.uid)
      }
    },
    handleFileExceed(type) {
      if (this.fileList[type].length >= this.limitNum) {
        this.$message.warning(`The current limit is ${this.limitNum}, please delete and upload again!`)
        return
      }
    },
    initData() {
      this.form = {
        mfa_code: undefined
      }
      this.$refs.form && this.$nextTick(() => { this.$refs.form.clearValidate() })
      this.currentFile = null
    },
    handleCancel() {
      this.dialogVisible = false
      this.fileList = []
    }
  }
}
</script>
<style>
.dialog-card {
  position: absolute;
  top: -10%;
}
.payout-upload-excel-file .el-icon-upload{
    font-size: 34px;
    color: #D3D7DF;
    margin: 28px 0 16px;
    line-height: 1;
}
</style>
<style lang="scss" scoped>
.payout-upload-excel-file ::v-deep .el-upload{
  display: block;
}
.upload-excel{
  width: 100%;
}
.btn-update{
  margin-left: 10px;
}
.upload-container{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 162px;
  background: #EDF2F9;
  border-radius: 4px;

    font-size: 12px;
    color: #8c939d;
    .icon-add{
      font-size: 8px;
    }
}
.parse{
    margin-top: 20px;
    font-size: 14px;
    color: #606266;
}
</style>
